import styled from "styled-components";
import AntButton from "uiKits/Button";
import AntTable from "uiKits/Table";
import { CONTENT_WIDTH, media, PAGE_GUTTER } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  margin-top: 45px;
  box-sizing: border-box;
  padding-left: ${PAGE_GUTTER.desktop}px;
  padding-right: ${PAGE_GUTTER.desktop}px;

  ${media.downTablet`
    width: 100%;
    padding-left: ${PAGE_GUTTER.tablet}px;
    padding-right: ${PAGE_GUTTER.tablet}px;
  `}

  ${media.downMobile`
    padding-left: ${PAGE_GUTTER.mobile}px;
    padding-right: ${PAGE_GUTTER.mobile}px;
  `}
`;

export const MainHeading = styled.h2`
  margin: 0px;
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  ${media.downMobile`
    font-size: 24px;
  `}
`;

export const MainSubHeading = styled.h2`
  margin: 0px;
  color: #6b7280;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 15.6px;
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 80px;
  gap: 16px;
  flex-wrap: wrap;

  ${media.downTablet`
    padding-bottom: 40px;
  `}

  ${media.downMobile`
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 24px;
  `}
`;

export const TableWrapper = styled.div`
  max-width: 100%;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const StyledTable = styled(AntTable)`
  .ant-table-thead tr th {
    text-align: center;
  }
  .ant-table-tbody tr td {
    text-align: center;
  }
`;

export const StyledButton = styled(AntButton)`
  font-size: 18px;
  height: 50px;
  padding: 4px 40px;

  ${media.downMobile`
    width: 100%;
    font-size: 16px;
    height: 44px;
    padding: 4px 20px;
  `}
`;
